const normalizedAddress = (address) => typeof address === 'string' ? address.trim() : '';

export const buildCustomerCreatePayload = (formData) => {
    const payload = {
        account_type: formData.account_type,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password,
        phone_num: formData.phone_num,
        address: normalizedAddress(formData.address),
    };

    if (formData.account_type === 'company') {
        payload.business_name = formData.business_name;
        payload.designation = formData.designation;
        payload.company_email = formData.company_email;
    }

    return payload;
};

export const getCustomerProfileFormData = (user) => ({
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    email: user.email || '',
    password: '',
    phone_num: user.phone_num || '',
    address: user.address || '',
    progress: user.progress || '',
    note_for_driver: user.note_for_driver || '',
    business_name: user.company?.business_name || '',
    designation: user.company?.designation || '',
    company_email: user.company?.email || '',
    is_manufacturer: !!user.is_manufacturer,
});

export const buildCustomerUpdatePayload = (formData) => ({
    ...formData,
    address: normalizedAddress(formData.address),
});
